module.exports = __webpack_public_path__ + "static/media/deletion.b9bcf73a.txt";